import OriginalAutocomplete from './Autocomplete.svelte';
import OriginalOptions from './Options.svelte';
import Option from './Option.svelte';
import EmptyOption from './EmptyOption.svelte';
import Label from './Label.svelte';
import Icon from '../icon/Icon.svelte';
const Autocomplete = OriginalAutocomplete;
Autocomplete.Options = OriginalOptions;
Autocomplete.Options.Option = Option;
Autocomplete.Options.EmptyOption = EmptyOption;
Autocomplete.Label = Label;
Autocomplete.Leading = Icon;
export default Autocomplete;
